import React from "react"
import styled from "styled-components"
import Container from "styleguide/components/grid/Container"
import Breadcrumbs from "styleguide/components/Nav/Breadcrumbs"
import media from "styleguide/styles/media-queries"

interface Props {
  breadcrumb: string
}

const Wrapper = styled.div`
  margin-bottom: 64px;

  ${media.tablet`
    margin-top: 168px;
  `}
`

const StyledBreadcrumbs = styled(Breadcrumbs)`
  display: inline-block;
`

const ArticleHero = ({ breadcrumb }: Props) => (
  <Wrapper>
    <Container>
      <StyledBreadcrumbs
        items={[{ title: "Blog", link: "/blog/" }]}
        currentItem={breadcrumb}
      />
    </Container>
  </Wrapper>
)

export default ArticleHero
